/*
 * Module for the Service Purhase "Purchase" tab
*/

rs.module("content/participant/member/servicepurchase/purchase",

    ["controls/navigation/tabstrip"],

    function (tabModule) {

        //
        // Initialize
        //
        function initialize(jsSelectors, calculateCostTabKey, contributionAllocationTabKey, paymentPlansTabKey, costCalcTabFlag, lumpSumFlag, payoffOptionsGrid, backendUrls,
            loanInterestPercent,
            originalBalance,
            downPayment,
            repayBeginDate,
            paymentFrequency,
            numberOfPayments) {

            var purchaseForm = $.js(jsSelectors.purchaseForm);
            var activateForm = $.js(jsSelectors.activateForm);
            var terminateForm = $.js(jsSelectors.terminateForm);
            var paymentScheduleModal = $.js(jsSelectors.paymentScheduleModal);
            var calculatePayoffModal = $.js(jsSelectors.calculatePayoffModal);

            var loadingTemplate = terminateForm.js(jsSelectors.loadingTemplate);
            var terminateContent = terminateForm.js(jsSelectors.terminateContent);

            // Open the calculate cost tab when the calculate cost link is clicked
            purchaseForm.js(jsSelectors.calculateCostLink, { required: false }).click(function () {

                // if this is a lump sum, set the focus to the lump sum text box as oppossed to opening the Calc Cost tab
                if (lumpSumFlag) {
                    purchaseForm.js(jsSelectors.lumpSumTextBox).select();
                }
                else if (costCalcTabFlag) {
                    tabModule.setSelectedTab(calculateCostTabKey);
                }
                else {
                    $(this).blur();
                }
            });

            // Open the contribution allocation tab when the contribution allocation link is clicked
            purchaseForm.js(jsSelectors.contributionAllocationsLink, { required: false }).click(function () {
                tabModule.setSelectedTab(contributionAllocationTabKey);
            });

            // Open the payment plans tab when the payment plans link is clicked
            purchaseForm.js(jsSelectors.paymentPlansLink, { required: false }).click(function () {
                tabModule.setSelectedTab(paymentPlansTabKey);
            });

            // Show the Activate popup when the Activate link is clicked.
            purchaseForm.js(jsSelectors.activateLink, { required: false }).click(function () {
                activateForm.js(jsSelectors.activateModal).modal('show');
            });

            // Hide errors when a payment plan is selected
            payoffOptionsGrid.selectionChanged(function (values, rows) {
                activateForm.js(jsSelectors.payoffOptionError).hide();
            });

            // When the Activate button is clicked, check whether a payoff option has been selected
            $.js(jsSelectors.activateForm).submit(function (e) {

                // Make sure a payoff option is selected
                var isValid = payoffOptionsGrid.selectedValues.length > 0;

                if (isValid) {
                    activateForm.js(jsSelectors.activateModal).modal('hide');
                }
                else {

                    activateForm.js(jsSelectors.payoffOptionError).show();
                    e.preventDefault();
                }
            });

            // Denotes whether the terminate popup has already been loaded
            var terminateAlreadyLoaded = false;

            // Load and show the terminate contract popup when the terminate link is clicked.
            purchaseForm.js(jsSelectors.terminateLink, { required: false }).click(function () {

                terminateForm.js(jsSelectors.terminateModal).modal('show');

                // Only make the backend call to load the popup the first time.
                // If it has already been loaded once, then we can just show it.
                if (!terminateAlreadyLoaded) {

                    terminateContent.hide();
                    loadingTemplate.show();

                    $.get(
                        backendUrls.loadTerminateContract, {}

                    ).done(function (results) {

                        loadingTemplate.hide();
                        terminateContent.show();

                        terminateForm.js(jsSelectors.contractService).html(results.contractService.toFixed(5));
                        terminateForm.js(jsSelectors.servicePosted).html(results.servicePostedToDate.toFixed(5));
                        terminateForm.js(jsSelectors.serviceNotPosted).html(results.serviceNotYetPosted.toFixed(5));
                        terminateForm.js(jsSelectors.incrementalService).html(results.incrementalServicePaidFor.toFixed(5));

                        terminateForm.js(jsSelectors.vestingContractService).html(results.vestingService.toFixed(5));
                        terminateForm.js(jsSelectors.vestingServicePosted).html(results.vestingServicePostedToDate.toFixed(5));
                        terminateForm.js(jsSelectors.vestingServiceNotPosted).html(results.vestingServiceNotYetPosted.toFixed(5));
                        terminateForm.js(jsSelectors.vestingIncrementalService).html(results.incrementalVestingServicePaidFor.toFixed(5));

                        // disable cancel service checkbox if there is no service to cancel
                        terminateForm.js(jsSelectors.cancelServiceCheckbox).prop("disabled", results.servicePostedToDate == 0);

                        // Set var that the popup has already been loaded
                        terminateAlreadyLoaded = true;

                    });
                }
            });

            // When the terminate button is clicked, check whether the form is valid
            $.js(jsSelectors.terminateForm).submit(function (e) {

                if (terminateForm.valid) {

                    terminateForm.js(jsSelectors.terminateModal).modal('hide');
                }
                else {

                    e.preventDefault();
                }
            });

            // Denotes whether the payment schedule popup has already been loaded
            var scheduleAlreadyLoaded = false;

            // Load and show the payment schedule popup when the payment schedule link is clicked.
            purchaseForm.js(jsSelectors.paymentScheduleLink, { required: false }).click(function () {

                paymentScheduleModal.modal('show');

                // Only make the backend call to load the popup the first time.
                // If it has already been loaded once, then we can just show it.
                if (!scheduleAlreadyLoaded) {

                    $.get(
                        backendUrls.loadPaymentSchedule,
                        {
                            loanInterestPercent: loanInterestPercent,
                            originalBalance: originalBalance,
                            downPayment: downPayment,
                            repayBeginDate: repayBeginDate,
                            paymentFrequency: paymentFrequency,
                            numberOfPayments: numberOfPayments
                        }

                    ).done(function (results) {

                        paymentScheduleModal.js(jsSelectors.paymentScheduleBody).html(results);

                        // Set var that the popup has already been loaded
                        scheduleAlreadyLoaded = true;
                    });
                }
            });

            // Show the calculate payoff popup when the calculate payoff amount link is clicked.
            purchaseForm.js(jsSelectors.calculatePayoffLink, { required: false }).click(function () {
                calculatePayoffModal.js(jsSelectors.payoffDate).val('').clearErrors();
                calculatePayoffModal.js(jsSelectors.payoffAmount).html(null);
                calculatePayoffModal.modal('show');
            });

            // Calculate the payoff amount
            calculatePayoffModal.js(jsSelectors.calculatePayoffButton).click(function () {

                calculatePayoffModal.js(jsSelectors.payoffAmount).html(null);

                var payOffDateInput = calculatePayoffModal.js(jsSelectors.payoffDate);

                // Make sure a payoff date is entered and valid before calculating
                if (payOffDateInput.valid()) {

                    calculatePayoffModal.js(jsSelectors.calcPayoffSpinner).show();

                    // make call to calculate payoff amount
                    $.get(
                        backendUrls.calculatePayoffAmount,
                        {
                            payoffDate: payOffDateInput.val()
                        }

                    ).done(function (results) {

                        calculatePayoffModal.js(jsSelectors.payoffAmount).html(results.value);

                    }).always(function () {

                        calculatePayoffModal.js(jsSelectors.calcPayoffSpinner).hide();
                    });
                }
                else {
                    calculatePayoffModal.js(jsSelectors.calcPayoffSpinner).hide();
                }
            });

            // Show/hide purchase type detail on hover
            purchaseForm.js(jsSelectors.purchaseTypeDetail).hoverIntent({
                handlerOver: function (event) {
                    purchaseForm.js(jsSelectors.purchaseTypeDetailPopup).show();
                },
                handlerOut: function (event) {
                    purchaseForm.js(jsSelectors.purchaseTypeDetailPopup).hide();
                },
                hoverOutDelay: 400
            });
            
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);